import { validationConstants } from "constants/formValidation";
import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { InputNumber } from "primereact/inputnumber";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

const StyledInputNumber = styled(InputNumber)`
  .p-inputtext {
    border: 2px solid #4f46e5 !important;
    color: #4f46e5 !important;
    font-weight: bold !important;
    ::-webkit-input-placeholder {
      color: #4f46e5 !important;
      font-weight: 400 !important;
    }
  }
`;

const StyledReadOnlyAmount = styled.div`
  border: 2px solid #4f46e5;
  color: #4f46e5;
  font-weight: bold;
  padding: 0.75rem;
  border-radius: 6px;
  font-size: 1.125rem;
  text-align: left;
`;

interface ITotalAmountProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
}

export function TotalAmount({ linkConfig }: ITotalAmountProps) {
  const {
    control,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();
  const { handleOnBlurField, getFormErrorMessage } = useFormValidation();

  const totalAmount = watch("totalAmount");
  const isAmountEditable = linkConfig ? linkConfig.amountEditable : true;

  return (
    <div className="field flex flex-column col-12 md:col-6">
      <Label htmlFor="totalAmount">
        Amount {!isAmountEditable && "(Fixed)"}
      </Label>
      {isAmountEditable ? (
        <Controller
          name="totalAmount"
          control={control}
          rules={{
            required:
              validationConstants.SERVICE_DETAILS.TOTAL_PATIENT_ESTIMATE,
          }}
          render={({ field: { onChange, value, onBlur } }) => (
            <>
              <StyledInputNumber
                currency="USD"
                locale="en-US"
                data-testid="totalAmount"
                id="totalAmount"
                mode="currency"
                placeholder="Amount"
                value={value}
                onBlur={() =>
                  handleOnBlurField({
                    onBlur,
                    field: "totalAmount",
                    trigger,
                  })
                }
                min={0}
                inputId="totalAmount"
                onChange={(e) => onChange(e.value)}
              />
              {getFormErrorMessage("totalAmount", errors)}
            </>
          )}
        />
      ) : (
        <StyledReadOnlyAmount>
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(totalAmount || 0)}
        </StyledReadOnlyAmount>
      )}
    </div>
  );
}
